/** Agent notifications page + inbox copy — non-English overrides */
export const panelAgentNotificationsByLang = {
  es: {
    'agent.page.notifications': 'Notificaciones',
    'agent.layout.nav.notifications': 'Notificaciones',
    'inbox.summary': '{{total}} en total · {{unread}} sin leer',
    'inbox.loadingSummary': 'Cargando…',
    'inbox.refresh': 'Actualizar',
    'inbox.refreshAria': 'Actualizar notificaciones',
    'inbox.markAllRead': 'Marcar todo como leído',
    'inbox.loadingList': 'Cargando notificaciones…',
    'inbox.empty': 'Aún no hay notificaciones.',
    'inbox.openRelated': 'Abrir página relacionada →',
    'inbox.markReadAria': 'Marcar como leído',
    'inbox.removeAria': 'Eliminar',
    'inbox.pageOf': 'Página {{current}} / {{total}}',
    'inbox.time.justNow': 'ahora mismo',
    'inbox.time.secAgo': 'hace {{sec}} s',
    'inbox.time.minAgo': 'hace {{min}} min',
    'inbox.time.hrAgo': 'hace {{hr}} h',
  },
  de: {
    'agent.page.notifications': 'Benachrichtigungen',
    'agent.layout.nav.notifications': 'Benachrichtigungen',
    'inbox.summary': '{{total}} gesamt · {{unread}} ungelesen',
    'inbox.loadingSummary': 'Wird geladen…',
    'inbox.refresh': 'Aktualisieren',
    'inbox.refreshAria': 'Benachrichtigungen aktualisieren',
    'inbox.markAllRead': 'Alle als gelesen markieren',
    'inbox.loadingList': 'Benachrichtigungen werden geladen…',
    'inbox.empty': 'Noch keine Benachrichtigungen.',
    'inbox.openRelated': 'Zugehörige Seite öffnen →',
    'inbox.markReadAria': 'Als gelesen markieren',
    'inbox.removeAria': 'Entfernen',
    'inbox.pageOf': 'Seite {{current}} / {{total}}',
    'inbox.time.justNow': 'gerade eben',
    'inbox.time.secAgo': 'vor {{sec}} s',
    'inbox.time.minAgo': 'vor {{min}} Min',
    'inbox.time.hrAgo': 'vor {{hr}} Std',
  },
  fr: {
    'agent.page.notifications': 'Notifications',
    'agent.layout.nav.notifications': 'Notifications',
    'inbox.summary': '{{total}} au total · {{unread}} non lues',
    'inbox.loadingSummary': 'Chargement…',
    'inbox.refresh': 'Actualiser',
    'inbox.refreshAria': 'Actualiser les notifications',
    'inbox.markAllRead': 'Tout marquer comme lu',
    'inbox.loadingList': 'Chargement des notifications…',
    'inbox.empty': 'Aucune notification pour le moment.',
    'inbox.openRelated': 'Ouvrir la page associée →',
    'inbox.markReadAria': 'Marquer comme lu',
    'inbox.removeAria': 'Supprimer',
    'inbox.pageOf': 'Page {{current}} / {{total}}',
    'inbox.time.justNow': 'à l’instant',
    'inbox.time.secAgo': 'il y a {{sec}} s',
    'inbox.time.minAgo': 'il y a {{min}} min',
    'inbox.time.hrAgo': 'il y a {{hr}} h',
  },
  ar: {
    'agent.page.notifications': 'الإشعارات',
    'agent.layout.nav.notifications': 'الإشعارات',
    'inbox.summary': '{{total}} إجمالي · {{unread}} غير مقروء',
    'inbox.loadingSummary': 'جاري التحميل…',
    'inbox.refresh': 'تحديث',
    'inbox.refreshAria': 'تحديث الإشعارات',
    'inbox.markAllRead': 'تعليم الكل كمقروء',
    'inbox.loadingList': 'جاري تحميل الإشعارات…',
    'inbox.empty': 'لا توجد إشعارات بعد.',
    'inbox.openRelated': 'فتح الصفحة المرتبطة →',
    'inbox.markReadAria': 'تعليم كمقروء',
    'inbox.removeAria': 'إزالة',
    'inbox.pageOf': 'صفحة {{current}} / {{total}}',
    'inbox.time.justNow': 'الآن',
    'inbox.time.secAgo': 'منذ {{sec}} ث',
    'inbox.time.minAgo': 'منذ {{min}} د',
    'inbox.time.hrAgo': 'منذ {{hr}} س',
  },
  ja: {
    'agent.page.notifications': '通知',
    'agent.layout.nav.notifications': '通知',
    'inbox.summary': '合計 {{total}} 件 · 未読 {{unread}} 件',
    'inbox.loadingSummary': '読み込み中…',
    'inbox.refresh': '更新',
    'inbox.refreshAria': '通知を更新',
    'inbox.markAllRead': 'すべて既読にする',
    'inbox.loadingList': '通知を読み込み中…',
    'inbox.empty': '通知はまだありません。',
    'inbox.openRelated': '関連ページを開く →',
    'inbox.markReadAria': '既読にする',
    'inbox.removeAria': '削除',
    'inbox.pageOf': '{{current}} / {{total}} ページ',
    'inbox.time.justNow': 'たった今',
    'inbox.time.secAgo': '{{sec}} 秒前',
    'inbox.time.minAgo': '{{min}} 分前',
    'inbox.time.hrAgo': '{{hr}} 時間前',
  },
  ko: {
    'agent.page.notifications': '알림',
    'agent.layout.nav.notifications': '알림',
    'inbox.summary': '총 {{total}}건 · 읽지 않음 {{unread}}건',
    'inbox.loadingSummary': '로딩 중…',
    'inbox.refresh': '새로고침',
    'inbox.refreshAria': '알림 새로고침',
    'inbox.markAllRead': '모두 읽음으로 표시',
    'inbox.loadingList': '알림 불러오는 중…',
    'inbox.empty': '아직 알림이 없습니다.',
    'inbox.openRelated': '관련 페이지 열기 →',
    'inbox.markReadAria': '읽음으로 표시',
    'inbox.removeAria': '삭제',
    'inbox.pageOf': '{{current}} / {{total}} 페이지',
    'inbox.time.justNow': '방금',
    'inbox.time.secAgo': '{{sec}}초 전',
    'inbox.time.minAgo': '{{min}}분 전',
    'inbox.time.hrAgo': '{{hr}}시간 전',
  },
  'zh-CN': {
    'agent.page.notifications': '通知',
    'agent.layout.nav.notifications': '通知',
    'inbox.summary': '共 {{total}} 条 · 未读 {{unread}} 条',
    'inbox.loadingSummary': '加载中…',
    'inbox.refresh': '刷新',
    'inbox.refreshAria': '刷新通知',
    'inbox.markAllRead': '全部标为已读',
    'inbox.loadingList': '正在加载通知…',
    'inbox.empty': '暂无通知。',
    'inbox.openRelated': '打开相关页面 →',
    'inbox.markReadAria': '标为已读',
    'inbox.removeAria': '删除',
    'inbox.pageOf': '第 {{current}} / {{total}} 页',
    'inbox.time.justNow': '刚刚',
    'inbox.time.secAgo': '{{sec}} 秒前',
    'inbox.time.minAgo': '{{min}} 分钟前',
    'inbox.time.hrAgo': '{{hr}} 小时前',
  },
  pt: {
    'agent.page.notifications': 'Notificações',
    'agent.layout.nav.notifications': 'Notificações',
    'inbox.summary': '{{total}} no total · {{unread}} não lidas',
    'inbox.loadingSummary': 'Carregando…',
    'inbox.refresh': 'Atualizar',
    'inbox.refreshAria': 'Atualizar notificações',
    'inbox.markAllRead': 'Marcar tudo como lido',
    'inbox.loadingList': 'Carregando notificações…',
    'inbox.empty': 'Ainda não há notificações.',
    'inbox.openRelated': 'Abrir página relacionada →',
    'inbox.markReadAria': 'Marcar como lida',
    'inbox.removeAria': 'Remover',
    'inbox.pageOf': 'Página {{current}} / {{total}}',
    'inbox.time.justNow': 'agora',
    'inbox.time.secAgo': 'há {{sec}} s',
    'inbox.time.minAgo': 'há {{min}} min',
    'inbox.time.hrAgo': 'há {{hr}} h',
  },
  it: {
    'agent.page.notifications': 'Notifiche',
    'agent.layout.nav.notifications': 'Notifiche',
    'inbox.summary': '{{total}} in totale · {{unread}} non lette',
    'inbox.loadingSummary': 'Caricamento…',
    'inbox.refresh': 'Aggiorna',
    'inbox.refreshAria': 'Aggiorna notifiche',
    'inbox.markAllRead': 'Segna tutte come lette',
    'inbox.loadingList': 'Caricamento notifiche…',
    'inbox.empty': 'Ancora nessuna notifica.',
    'inbox.openRelated': 'Apri pagina correlata →',
    'inbox.markReadAria': 'Segna come letta',
    'inbox.removeAria': 'Rimuovi',
    'inbox.pageOf': 'Pagina {{current}} / {{total}}',
    'inbox.time.justNow': 'adesso',
    'inbox.time.secAgo': '{{sec}} s fa',
    'inbox.time.minAgo': '{{min}} min fa',
    'inbox.time.hrAgo': '{{hr}} h fa',
  },
  ru: {
    'agent.page.notifications': 'Уведомления',
    'agent.layout.nav.notifications': 'Уведомления',
    'inbox.summary': 'Всего {{total}} · непрочитанных {{unread}}',
    'inbox.loadingSummary': 'Загрузка…',
    'inbox.refresh': 'Обновить',
    'inbox.refreshAria': 'Обновить уведомления',
    'inbox.markAllRead': 'Пометить всё прочитанным',
    'inbox.loadingList': 'Загрузка уведомлений…',
    'inbox.empty': 'Пока нет уведомлений.',
    'inbox.openRelated': 'Открыть связанную страницу →',
    'inbox.markReadAria': 'Отметить как прочитанное',
    'inbox.removeAria': 'Удалить',
    'inbox.pageOf': 'Страница {{current}} / {{total}}',
    'inbox.time.justNow': 'только что',
    'inbox.time.secAgo': '{{sec}} с назад',
    'inbox.time.minAgo': '{{min}} мин назад',
    'inbox.time.hrAgo': '{{hr}} ч назад',
  },
  bn: {
    'agent.page.notifications': 'বিজ্ঞপ্তি',
    'agent.layout.nav.notifications': 'বিজ্ঞপ্তি',
    'inbox.summary': 'মোট {{total}} · অপঠিত {{unread}}',
    'inbox.loadingSummary': 'লোড হচ্ছে…',
    'inbox.refresh': 'রিফ্রেশ',
    'inbox.refreshAria': 'বিজ্ঞপ্তি রিফ্রেশ করুন',
    'inbox.markAllRead': 'সব পঠিত চিহ্নিত করুন',
    'inbox.loadingList': 'বিজ্ঞপ্তি লোড হচ্ছে…',
    'inbox.empty': 'এখনও কোনো বিজ্ঞপ্তি নেই।',
    'inbox.openRelated': 'সম্পর্কিত পৃষ্ঠা খুলুন →',
    'inbox.markReadAria': 'পঠিত চিহ্নিত করুন',
    'inbox.removeAria': 'সরান',
    'inbox.pageOf': 'পৃষ্ঠা {{current}} / {{total}}',
    'inbox.time.justNow': 'এইমাত্র',
    'inbox.time.secAgo': '{{sec}} সেক আগে',
    'inbox.time.minAgo': '{{min}} মি আগে',
    'inbox.time.hrAgo': '{{hr}} ঘণ্টা আগে',
  },
  hi: {
    'agent.page.notifications': 'सूचनाएँ',
    'agent.layout.nav.notifications': 'सूचनाएँ',
    'inbox.summary': 'कुल {{total}} · अपठित {{unread}}',
    'inbox.loadingSummary': 'लोड हो रहा है…',
    'inbox.refresh': 'रीफ़्रेश',
    'inbox.refreshAria': 'सूचनाएँ रीफ़्रेश करें',
    'inbox.markAllRead': 'सभी को पढ़ा हुआ चिह्नित करें',
    'inbox.loadingList': 'सूचनाएँ लोड हो रही हैं…',
    'inbox.empty': 'अभी कोई सूचना नहीं।',
    'inbox.openRelated': 'संबंधित पृष्ठ खोलें →',
    'inbox.markReadAria': 'पढ़ा हुआ चिह्नित करें',
    'inbox.removeAria': 'हटाएँ',
    'inbox.pageOf': 'पृष्ठ {{current}} / {{total}}',
    'inbox.time.justNow': 'अभी',
    'inbox.time.secAgo': '{{sec}} सेकंड पहले',
    'inbox.time.minAgo': '{{min}} मिनट पहले',
    'inbox.time.hrAgo': '{{hr}} घंटे पहले',
  },
};
